import React from 'react'
import { Box, Typography } from '@material-ui/core'

export default function OrDivider() {
  return (
    <Box my={2} alignItems='center' display='flex'>
      <Box borderBottom={1} width='100%' />
        <Box mx={1} component='span'><Typography variant='subtitle1'>or</Typography></Box>
      <Box borderBottom={1} width='100%' />
    </Box>
  )
}
